import React from 'react';
import { flatten } from 'lodash-es';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { CmsModel } from 'client/data/models/cms';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { parseContent } from 'client/data/cms/content';
import { getModelState } from 'client/data/luckdragon/model';
import { getTypeArticlesLandingBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { getEditorialNewsArticleSchema } from 'client/seo/schemas/article';
import { getListItemSchema } from 'client/seo/schemas/list';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getTypeArticlesLandingPath } from 'site-modules/editorial/utils/content-path';
import { RENDER_TYPE } from 'site-modules/editorial/components/type/type-articles-landing/research-entry/research-entry';
import { TypeArticlesLanding } from './type-articles-landing';

export const pageOptions = ({ type }) => ({
  name: `advice_${type}_article_index`,
  category: 'advice',

  seo: state => {
    const modelState = getModelState(state);
    const articlePath = getTypeArticlesLandingPath(type);
    const content = parseContent(modelState.get(`content["${articlePath}"]`, CmsModel));

    const articles = flatten(
      content
        .child('main')
        .children()
        .filter(childEntry =>
          [RENDER_TYPE.ARTICLES_CAROUSEL, RENDER_TYPE.ARTICLES_GRID].includes(childEntry.metadata('renderType').value())
        )
        .map(articlesEntry => articlesEntry.children().map(articleEntry => articleEntry.getAllMetadata()))
    ).map(
      ({
        'link-url': url,
        'promo-text': title,
        'media-image': image,
        'article-date': publishDate,
        authorName: author,
      }) => ({ url, title, image, publishDate, author })
    );
    const meta = getMeta(content);

    return {
      ...meta,
      jsonld: [
        getListItemSchema({
          name: content.metadata('titleTag').value(),
          items: articles.map(({ url, title: articleTitle }, ind) => ({
            position: ind + 1,
            name: articleTitle,
            url: `https://www.edmunds.com${url}`,
          })),
          pageUrl: `https://www.edmunds.com/${type}/articles/`,
        }),
        getBreadcrumbSchema(getTypeArticlesLandingBreadcrumbs(content.title, type)),
        ...articles.map(article => getEditorialNewsArticleSchema({ article, author: article.author })),
      ],
    };
  },
  component: props => <TypeArticlesLanding {...props} type={type} />,
});

export default ({ type }) => pageDefinition(pageOptions({ type }));
